module.exports = __webpack_public_path__ + "img/exam (4).4998bfba.png";